var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Motion, spring } from 'react-motion';
import { useTheme, useMotionConfig } from '@nivo/core';

var CrosshairLine = memo(function (_ref) {
    var x0 = _ref.x0,
        x1 = _ref.x1,
        y0 = _ref.y0,
        y1 = _ref.y1;

    var theme = useTheme();

    var _useMotionConfig = useMotionConfig(),
        animate = _useMotionConfig.animate,
        springConfig = _useMotionConfig.springConfig;

    var style = useMemo(function () {
        return _extends({}, theme.crosshair.line, {
            pointerEvents: 'none'
        });
    }, [theme.crosshair.line]);

    if (animate !== true) {
        return React.createElement('line', { x1: x0, x2: x1, y1: y0, y2: y1, fill: 'none', style: style });
    }

    return React.createElement(
        Motion,
        {
            style: {
                x0: spring(x0, springConfig),
                x1: spring(x1, springConfig),
                y0: spring(y0, springConfig),
                y1: spring(y1, springConfig)
            }
        },
        function (line) {
            return React.createElement('line', {
                x1: line.x0,
                x2: line.x1,
                y1: line.y0,
                y2: line.y1,
                fill: 'none',
                style: style
            });
        }
    );
});

CrosshairLine.displayName = 'CrosshairLine';
CrosshairLine.propTypes = process.env.NODE_ENV !== "production" ? {
    x0: PropTypes.number.isRequired,
    x1: PropTypes.number.isRequired,
    y0: PropTypes.number.isRequired,
    y1: PropTypes.number.isRequired
} : {};

export default CrosshairLine;